const translation = {
  // Navigation
  "nav.home": "Strona główna",
  "nav.categories": "Kategorie",
  "nav.articles": "Artykuły",
  "nav.about": "O nas",
  "nav.shopping_guide": "Przewodnik zakupowy",

  // Hero
  "hero.title": "USFansSpreadsheet – Kompletny przewodnik, bezpieczeństwo i porównania 2026",
  "hero.subtitle": "Dowiedz się, jak działa USFansSpreadsheet, poznaj funkcje, bezpieczeństwo i najlepsze alternatywy. Sprawdź nasze poradniki i recenzje.",
  "hero.cta_guide": "usfans spreadsheet",
  "hero.cta_buy": "buy it now",

  // Categories
  "categories.title": "Kategorie produktów",
  "categories.subtitle": "Przeglądaj nasze kategorie i znajdź idealne produkty w sklepie Kaspreadsheet. Każda kategoria prowadzi do starannie wyselekcjonowanych arkuszy i akcesoriów.",
  "categories.shoes": "Buty",
  "categories.hoodies": "Bluzy / Swetry",
  "categories.tshirts": "T-Shirty",
  "categories.jackets": "Kurtki",
  "categories.pants": "Spodnie / Szorty",
  "categories.headwear": "Nakrycia głowy",
  "categories.sets": "Zestawy",
  "categories.underwear": "Bielizna",
  "categories.jersey": "Koszulki sportowe",
  "categories.accessories": "Akcesoria",
  "categories.bags": "Torby",
  "categories.belts": "Paski",
  "categories.perfumes": "Perfumy",
  "categories.other": "Inne produkty",
  "categories.goto": "Przejdź do sklepu",

  // About / What Is section
  "about.label": "Czym jest USFansSpreadsheet?",
  "about.description": "USFansSpreadsheet to zaawansowane narzędzie do zarządzania arkuszami kalkulacyjnymi, zaprojektowane z myślą o użytkownikach poszukujących szybkiego i bezpiecznego dostępu do danych. Platforma oferuje intuicyjny interfejs, wsparcie dla wielu formatów oraz zaawansowane funkcje analityczne, które pomagają w codziennej pracy z danymi. Niezależnie od tego, czy dopiero zaczynasz swoją przygodę z arkuszami, czy jesteś zaawansowanym użytkownikiem — USFansSpreadsheet zapewnia narzędzia dopasowane do Twoich potrzeb. W połączeniu z ekosystemem Kaspreadsheet tworzy kompletne rozwiązanie dla każdego.",

  // Features grid
  "features.title_line1": "Funkcje i",
  "features.title_line2": "bezpieczeństwo",
  "features.sheet_management": "Zarządzanie arkuszami",
  "features.security": "Bezpieczeństwo danych",
  "features.analytics": "Analiza i raporty",

  // Articles section
  "articles.label": "Poradniki SEO",
  "articles.title": "Artykuły i recenzje USFansSpreadsheet",
  "articles.guide_title": "Kompletny przewodnik po USFansSpreadsheet",
  "articles.guide_excerpt": "Wszystko, co musisz wiedzieć o USFansSpreadsheet – od instalacji po zaawansowane funkcje. Poradnik krok po kroku dla początkujących i zaawansowanych użytkowników.",
  "articles.safety_title": "Czy USFansSpreadsheet jest bezpieczny?",
  "articles.safety_excerpt": "Sprawdzamy wszystkie aspekty bezpieczeństwa – szyfrowanie danych, prywatność użytkowników i zgodność z regulacjami. Pełna analiza bezpieczeństwa narzędzia.",
  "articles.comparison_title": "USFansSpreadsheet vs alternatywy",
  "articles.comparison_excerpt": "Porównujemy USFansSpreadsheet z najpopularniejszymi alternatywami na rynku. Które narzędzie najlepiej spełni Twoje oczekiwania?",
  "articles.tutorial_title": "Jak korzystać z USFansSpreadsheet",
  "articles.tutorial_excerpt": "Praktyczny poradnik krok po kroku – naucz się efektywnie wykorzystywać wszystkie funkcje USFansSpreadsheet.",
  "articles.review_title": "USFansSpreadsheet opinie 2026",
  "articles.review_excerpt": "Szczera recenzja USFansSpreadsheet – zalety, wady i opinie prawdziwych użytkowników. Czy warto?",
  "articles.howto_title": "Jak używać USFansSpreadsheet – poradnik krok po kroku",
  "articles.howto_excerpt": "Praktyczne wskazówki i triki dla początkujących użytkowników USFansSpreadsheet. Naucz się efektywnie tworzyć i zarządzać arkuszami.",
  "articles.alternatives_title": "5 najlepszych alternatyw dla USFansSpreadsheet",
  "articles.alternatives_excerpt": "Przegląd konkurencyjnych narzędzi i ich porównanie z USFansSpreadsheet. Które rozwiązanie wybrać w 2026 roku?",
  "articles.beginners_title": "USFansSpreadsheet dla początkujących",
  "articles.beginners_excerpt": "Wprowadzenie do świata USFansSpreadsheet – od podstaw po pierwsze zaawansowane funkcje. Idealny start dla nowych użytkowników.",
  "articles.features_title": "Najważniejsze funkcje USFansSpreadsheet w 2026",
  "articles.features_excerpt": "Odkryj wszystkie kluczowe funkcje USFansSpreadsheet i dowiedz się, które z nich najbardziej przydadzą się w Twojej codziennej pracy.",
  "articles.privacy_title": "Prywatność i ochrona danych w USFansSpreadsheet",
  "articles.privacy_excerpt": "Szczegółowa analiza polityki prywatności i mechanizmów ochrony danych osobowych w USFansSpreadsheet.",
  "articles.mobile_title": "USFansSpreadsheet na urządzeniach mobilnych",
  "articles.mobile_excerpt": "Jak korzystać z USFansSpreadsheet na smartfonie i tablecie. Pełna funkcjonalność w wersji mobilnej.",
  "articles.tips_title": "10 praktycznych wskazówek dla USFansSpreadsheet",
  "articles.tips_excerpt": "Sprawdzone triki i strategie, które pomogą Ci pracować szybciej i efektywniej z USFansSpreadsheet.",
  "articles.integration_title": "Integracja USFansSpreadsheet z innymi narzędziami",
  "articles.integration_excerpt": "Jak połączyć USFansSpreadsheet z popularnymi aplikacjami i usługami, aby zautomatyzować swoją pracę.",
  "articles.community_title": "Społeczność USFansSpreadsheet – forum i wsparcie",
  "articles.community_excerpt": "Poznaj społeczność użytkowników USFansSpreadsheet – gdzie szukać pomocy i dzielić się doświadczeniami.",
  "articles.read_more": "Czytaj więcej",

  // CTA section
  "cta.title": "usfansspreadsheet",
  "cta.description": "Odkryj pełną kolekcję produktów w oficjalnym sklepie.",
  "cta.button": "buy it now",

  // Footer
  "footer.description": "USFansSpreadsheet.help to niezależny portal informacyjny poświęcony narzędziu USFansSpreadsheet. Znajdziesz tu poradniki, recenzje, porównania i informacje o bezpieczeństwie.",
  "footer.newsletter": "NEWSLETTER",
  "footer.newsletter_placeholder": "Twój adres email",
  "footer.newsletter_hint": "Zapisz się, aby otrzymywać najnowsze poradniki i aktualizacje.",
  "footer.categories_title": "KATEGORIE",
  "footer.social": "SOCIAL",
  "footer.copyright": "© 2026 USFansSpreadsheet.help. Wszelkie prawa zastrzeżone.",

  // SEO Article Page
  "article.back_home": "← Powrót do strony głównej",
  "article.breadcrumb_home": "Strona główna",
  "article.breadcrumb_articles": "Artykuły",
  "article.updated": "Zaktualizowano: Czerwiec 2026",
  "article.author": "Autor: Anna Kowalska",
  "article.author_role": "Specjalista SEO, Badacz cyfrowy",
  "article.related": "Powiązane artykuły",

  // Trust badges
  "trust.updated": "Aktualizowane regularnie",
  "trust.expert": "Eksperckie poradniki",
  "trust.comparison": "Porównania narzędzi",
  "trust.safety": "Informacje o bezpieczeństwie",

  // FAQ
  "faq.title": "Najczęściej zadawane pytania",

  // Shopping Guide
  "shopping.title": "Przewodnik zakupowy USFansSpreadsheet",
  "shopping.subtitle": "Wszystko, co musisz wiedzieć przed zakupem produktów USFansSpreadsheet w sklepie Kaspreadsheet.",
};

export default translation;